import React from "react";
import {Container, Divider, Link, Paper, Typography} from "@mui/material";
import ArrowCircleRightOutlinedIcon from "@mui/icons-material/ArrowCircleRightOutlined";
import {useTranslation} from "react-i18next";
import parse from 'html-react-parser';


const Question = (props) => {
    const {children, ...other} = props;
    return <Typography {...other} fontWeight="bold" display="flex" alignItems="center" mt={2} mb={1}>
        <ArrowCircleRightOutlinedIcon fontSize="small" sx={{mr: 1}}/>
        {children}
    </Typography>
}

const Response = (props) => {
    const {children, ...other} = props;
    return <Typography {...other}>{children}</Typography>
}

export default function Help() {
    const {t} = useTranslation('common');
    return (
        <Container sx={{mb: 2, mt: 2, flexGrow: 1, display: "flex"}}>
            <Paper sx={{flexGrow: 1, p: 2}} elevation={0}>

                <Typography variant="h6" fontWeight="bold" color="textSecondary">{t("help.search.title")}</Typography>
                <Typography component={"div"}>{parse(t("help.search.body"))}</Typography>
                <Divider sx={{m: 2}}/>
                <Typography variant="h6" fontWeight="bold" color="textSecondary">{t("help.viewer.title")}</Typography>
                <Typography component={"div"}>{parse(t("help.viewer.body"))}</Typography>
                <Divider sx={{m: 2}}/>
                <Typography variant="h6" fontWeight="bold" color="textSecondary">{t("help.faq.title")}</Typography>

                <Question>{t("help.faq.question.q1")}</Question>
                <Response>{t("help.faq.response.r1")}</Response>

                <Question>{t("help.faq.question.q2")}</Question>
                <Response>{t("help.faq.response.r2")}
                    <Link target="_blank" href="http://fr.wikipedia.org/wiki/Optical_character_recognition"> Optical
                        character
                        recognition
                    </Link>
                </Response>
                {Array.from({length: 2}, (_, i) => i + 3).map((i) => (
                    <div key={`faq-${i}`}>
                        <Question>{t(`help.faq.question.q${i}`)}</Question>
                        <Response>{t(`help.faq.response.r${i}`)}</Response>
                    </div>
                ))}
            </Paper>
        </Container>
    );
}